import '@aws-amplify/ui-react/styles.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { ThemeProvider } from '@aws-amplify/ui-react';
import { AppTheme } from './amplifytheme';

// providers
import { Provider } from 'react-redux';
import { AuthenticatorProvider } from './providers/authentication.amplify';
import { UserProvider } from './providers/user';
import { ConfigProvider } from './providers/config';
import { RealtimeJobsProvider } from './providers/realtime.jobs';
import { AppRouters } from './screens/routers';

// app
import { setupStore } from './stores';

const {
  REACT_APP_REGION,
  REACT_APP_API_BASEURL,
  REACT_APP_API_STAGE,
  REACT_APP_GRAPHQL,
  REACT_APP_AUTH_POOL_ID,
  REACT_APP_AUTH_CLIENT_ID,
  REACT_APP_IDENTITY_POOL_ID,
  REACT_APP_AUTH_DOMAIN,
  REACT_APP_AUTH_REDIRECT_URI,
  REACT_APP_AUTH_REDIRECT_SIGNOUT_URI,
  REACT_APP_GEO_MAP_NAME,
  REACT_APP_GEO_MAP_STYLE,
  REACT_APP_SHARED_BUCKET_NAME,
} = process.env;

// config
const amplifyConfig = {
  Auth: {
    Cognito: {
      identityPoolId: REACT_APP_IDENTITY_POOL_ID,
      allowGuestAccess: true,
      userAttributes: {
        email: {
          required: true
        },
      },
      userPoolClientId: REACT_APP_AUTH_CLIENT_ID,
      userPoolId: REACT_APP_AUTH_POOL_ID,
      mfa: {
        status: "off",
        totpEnabled: false,
        smsEnabled: false
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true
      },
      loginWith: {
        username: false,
        email: true,
        phone: false,
        oauth: {
          domain: REACT_APP_AUTH_DOMAIN,
          scopes: [
            "aws.cognito.signin.user.admin",
            "email",
            "openid",
            "profile"
          ],
          redirectSignIn: [REACT_APP_AUTH_REDIRECT_URI],
          redirectSignOut: [REACT_APP_AUTH_REDIRECT_SIGNOUT_URI],
          responseType: "code",
        }
      }
    }
  },
  API: {
    REST: {
      AccountApi: {
        endpoint:
          `${REACT_APP_API_BASEURL}/${REACT_APP_API_STAGE}`,
        region: REACT_APP_REGION,
      }
    },
    GraphQL: {
      endpoint: REACT_APP_GRAPHQL,
      region: REACT_APP_REGION,
      defaultAuthMode: 'iam',
    },
  },
  Storage: {
    region: REACT_APP_REGION,
    bucket: REACT_APP_SHARED_BUCKET_NAME,
    S3: {
      region: REACT_APP_REGION,
      bucket: REACT_APP_SHARED_BUCKET_NAME,
    }
  },
  Geo: {
    LocationService: {
      maps: {
        items: {
          [REACT_APP_GEO_MAP_NAME]: {
            style: REACT_APP_GEO_MAP_STYLE
          }
        },
        default: REACT_APP_GEO_MAP_NAME
      },
      region: REACT_APP_REGION
    },
  },
}
Amplify.configure(amplifyConfig);
console.log('App.App', 'amplifyConfig', amplifyConfig);

// config store
console.log('App.App', 'NODE_ENV', process.env.NODE_ENV);
const store = setupStore({});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Provider store={store}>
      <ThemeProvider theme={AppTheme}>
        <AuthenticatorProvider>
          <UserProvider>
            <ConfigProvider>
              <RealtimeJobsProvider />
              <AppRouters />
            </ConfigProvider>
          </UserProvider>
        </AuthenticatorProvider>
      </ThemeProvider>
    </Provider>
  </>
);
